module.exports = __webpack_public_path__ + "img/pin.cc5a6543.svg";